/** Mirror backend `StudentCurriculumOperations.IsInstructionalUnit` (instructional = has lessons). */

import { UnitStateKey } from '../../InProgressUnitsPanel/lessonStepState';

export type InstructionalRollupKind = 'none' | 'allComplete' | 'active';

export function normalizeTopicId(id: string | null | undefined): string | null {
    if (!id || typeof id !== 'string') return null;
    const t = id.trim().toLowerCase();
    return t ? t : null;
}

export function isBackendInstructionalUnit(unit: any): boolean {
    const lessons = unit?.e251_Lessons;
    return Array.isArray(lessons) && lessons.length > 0;
}

export function unitBackendStateIsComplete(state: string | undefined): boolean {
    return state === UnitStateKey.Complete;
}

export function filterInstructionalUnitsForTopic(units: any[] | undefined, topicId: string | null | undefined): any[] {
    if (!units?.length) return [];
    const n = normalizeTopicId(topicId);
    if (!n) return [];

    const out: any[] = [];
    for (const u of units) {
        if (!isBackendInstructionalUnit(u)) continue;
        const ids: string[] = u?.e251_TopicIds || [];
        if (!ids.some(tid => normalizeTopicId(tid) === n)) continue;
        out.push(u);
    }
    return out;
}

export function getTopicInstructionalRollup(
    units: any[] | undefined,
    topicId: string | null | undefined
): { qualifyingUnits: any[]; rollup: InstructionalRollupKind } {
    const qualifying = filterInstructionalUnitsForTopic(units, topicId);
    if (qualifying.length === 0) return { qualifyingUnits: [], rollup: 'none' };
    const allComplete = qualifying.every(u => unitBackendStateIsComplete(u?.e251_State));
    return { qualifyingUnits: qualifying, rollup: allComplete ? 'allComplete' : 'active' };
}
